import React from 'react'
import classNames from 'classnames'
import { Button, TButtonProps } from 'transfix-ui/components/Button'
import { INavigationRoute } from 'transfix-ui/components/NavigationBar/types'
import NavigationItemMenu from 'transfix-ui/components/NavigationItemMenu'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import SubRoutesMenu from './SubRoutesMenu'

const NAVBAR_HEIGHT_PX = 48

interface INavigationButtonItemProps extends Omit<TButtonProps, 'onClick'> {
  route: INavigationRoute
}

const useNavigationItemButtonStyles = makeStyles(theme => ({
  root: {
    display: 'none',
    flex: '0 0 auto',
    position: 'relative',
    height: NAVBAR_HEIGHT_PX,
    backgroundColor: brandColors.coolGray8,
    color: brandColors.coolGray4,
    alignItems: 'center',
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),

    /**
     * On tablet and above, show this item
     */
    [theme.breakpoints.up('md')]: {
      display: 'inline-flex',
    },
  },
  button: {
    '&.MuiButton-containedSecondary': {
      backgroundColor: 'transparent',

      '&.active': {
        backgroundColor: 'transparent',
      },
    },
  },
  childRouteMenu: {},
}))

const NavigationItemButton = ({
  className: classNameProp,
  route: routeProp,
}: INavigationButtonItemProps) => {
  const {
    childRoutes = [],
    ButtonProps = {},
    location,
    Menu = NavigationItemMenu,
    MenuProps,
    name,
  } = routeProp || {}
  const classes = useNavigationItemButtonStyles()
  const className = classNames(classes.root, classNameProp)
  return (
    <li data-test='NavigationItemButton' className={className}>
      <Button href={location} className={classes.button} {...ButtonProps}>
        {name}
      </Button>
      {MenuProps && <Menu {...MenuProps} />}
      {childRoutes && <SubRoutesMenu routes={childRoutes} />}
    </li>
  )
}

export default NavigationItemButton
